export default function resizeCanvas(scale, parent, canvas, ctx) {
  const w = parent.offsetWidth;
  const h = parent.offsetHeight;

  canvas.width = w * scale;
  canvas.height = h * scale;

  canvas.style.width = `${w}px`;
  canvas.style.height = `${h}px`;

  ctx.scale(scale, scale);
}
